import { DiagnosisPatient } from '../model/http/prescriptionName';
import { StringConst } from './const';

export const DiagnosisCanAddDiagnostic = 'BQR';

export const DermazoneValue = 'DERMAZONE';

export const noDiagnosis: DiagnosisPatient = {
    diagnosis: 'Sin diagnóstico',
    id: '',
};
export class GenderConfig {
    value = StringConst.empty;
    description = StringConst.empty;
}
export const GenderList: GenderConfig[] = [
    {
        value: 'Masculino',
        description: 'M'
    },
    {
        value: 'Femenino',
        description: 'F'
    }
];
